import { jsx as _jsx } from "react/jsx-runtime";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import { useRef, useMemo } from "react";
if (typeof Highcharts === "object") {
    HighchartsExporting(Highcharts);
}
export const WkoHighchart = ({ options, csvData, csvFileName }) => {
    const chartRef = useRef(null);
    const mergedOptions = useMemo(() => ({
        credits: { enabled: false },
        chart: {
            backgroundColor: "transparent",
            styledMode: true,
            ...options.chart,
        },
        title: { text: undefined, ...options.title },
        xAxis: {
            type: "datetime",
            dateTimeLabelFormats: { month: '%b-%y' },
            ...options.xAxis,
        },
        yAxis: {
            title: { text: undefined },
            min: 0,
            ...options.yAxis,
        },
        legend: {
            enabled: true,
            align: "left",
            borderWidth: 0,
            itemStyle: { fontSize: "8pt" },
            ...options.legend,
        },
        plotOptions: {
            spline: {
                lineWidth: 2,
                states: { hover: { lineWidth: 4 } },
                marker: { enabled: false },
            },
            column: {
                stacking: "normal",
                dataLabels: { enabled: false },
            },
            series: {
                cursor: "pointer",
            },
            ...options.plotOptions,
        },
        exporting: {
            enabled: true,
            menuItemDefinitions: {
                exportCSV: {
                    onclick: function () {
                        if (csvData) {
                            exportCsv(csvData, csvFileName ?? "chart_export");
                        }
                    },
                    text: "Download CSV",
                },
            },
            buttons: {
                contextButton: {
                    menuItems: ["downloadPNG", "downloadPDF", "exportCSV"],
                },
            },
            ...options.exporting,
        },
        tooltip: options.tooltip,
        series: options.series,
    }), [options, csvData, csvFileName]);
    return _jsx(HighchartsReact, { highcharts: Highcharts, options: mergedOptions, ref: chartRef });
};
const exportCsv = (csvContent, chartName) => {
    const encoded = "data:text/csv;charset=utf-8," + csvContent;
    const fileName = `${chartName}_${new Date().toISOString().replace(/[:.]/g, "-")}.csv`;
    const encodedUri = encodeURI(encoded);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
